
import { Link } from 'react-router-dom';


import { LocaleContext } from '../../../locale-context';

export function Table() {
    return (
        <LocaleContext.Consumer>
            {(value) => {
                if (value === "en") {
                    return <div>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">PROCEDURE</div>
                                    <div class="divTableCell">RECOMMENDATION</div>
                                    <div class="divTableCell">EXPLANATION</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Diagnostic hysteroscopy</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">In patients experiencing RIF, hysteroscopy may be beneficial</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometrial receptivity tests (ERA)</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Lack of clear benefit</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Reproductive immunology tests and treatments</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No reliable normal reference ranges/ absence of any rationale, documented side-effects, and no clinical benefit</div>
                                </div>
                            </div>
                        </div>

                        <h2>Laboratory tests and interventions</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">PROCEDURE</div>
                                    <div class="divTableCell">RECOMMENDATION</div>
                                    <div class="divTableCell">EXPLANATION</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Artificial oocyte activation</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Can be effective for cases of TFF (0% 2PN), very low fertilisation ({'<'}30%) or globozoospermia</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mithocondrial replacement therapy</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Not allowed outside strict research protocols</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVA</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Limited efficacy, potentially high cost and safety concerns</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVM</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Absence of long-term safety data, procedural reliability, and effectiveness.</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Sperm DNA damage testing/tx</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Only under strict research protocols</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Artificial sperm activation</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Only for primary or secondary total asthenozoospermia</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Sperm evaluation and selection</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>

                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PICSI</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Limited standardisation and the limited clinical value</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">MACS</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Insufficient evidence</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Microfluidics</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">More research is needed</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IMSI</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No benefit shown</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Growth factor-supplemented embryo culture medium</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Insufficient evidence</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Assisted hatching</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No benefit, increase in MZ twinning</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Genetic testing/treatments</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PGT-A</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">May decrease time to pregnancy in specific patient groups</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">NiPGT</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Not suitable for clinical application yet</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mitochondria DNA load measurement</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Both niPGT and mtDNA load measurements are to be considered in research phase</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Time-lapse imaging (TLI)</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Not been shown to improve the LBR</div>
                                </div>
                            </div>
                        </div>

                        <h2>Clinical Management</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">PROCEDURE</div>
                                    <div class="divTableCell">RECOMMENDATION</div>
                                    <div class="divTableCell">EXPLANATION</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PRP (Platelet Rich Plasma)</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Not recommended outside strict research protocols</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Duostim</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No data on the efficacy and safety. Can be used for urgent fertility preservation but requires further research in poor responders</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Adjuncts during ovarian stimulation</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Metformin, GH, testosterone, DHEA, aspirin, indomethacin,  sildenafil</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Intravaginal ve intrauterine culture device</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No evidence</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Additions to culture media (HA)</div>
                                    <div class="divTableCell">YES?</div>
                                    <div class="divTableCell">HA addition to transfer media is recommended to be performed only within a single embryo transfer policy program</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometrial scratching</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Further studies are needed if it is to be recommended</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Flushing of the uterus (Hcg, G-CSF, emryo culture supernatant, seminal plasma)</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Further trials are necessary</div>

                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Stem cell mobilization</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No rationale. Further preclinical studies should evaluate the relevance of this technique </div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Steroids</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Available data does not support routine administration</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Elective freeze-all</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Should only be adopted if there is a definite clinical indication</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">ICSI for non-male factor infertility</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">ICSI should not be recommended in case of non-male factor infertility.</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Antioxidant therapy in male or female patients</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">No sufficiently reliable and good quality evidence</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Complementary/alternative medicine</div>
                                    <div class="divTableCell">NO</div>
                                    <div class="divTableCell">Conflicting or no clinical studies</div>
                                </div>
                            </div>
                        </div>
                    </div>

                } else if (value === "tr") {
                    return <div>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">İŞLEM</div>
                                    <div class="divTableCell">ÖNERİ</div>
                                    <div class="divTableCell">AÇIKLAMA</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Tanısal histeroskopi</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Tekrarlayan tüp bebek başarısızlıklarında yararı olabilir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometrial reseptivite testleri (ERA)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Açık bir yararı gösterilememiştir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Reproductive immunology tests and treatments</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Güvenilir referans aralıkları yok/gerekçe, yan etkiler ve klinik yararı belirsiz</div>
                                </div>
                            </div>
                        </div>

                        <h2>Laboratuvar testleri ve girişimleri</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">İŞLEM</div>
                                    <div class="divTableCell">ÖNERİ</div>
                                    <div class="divTableCell">AÇIKLAMA</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Yumurtanın yapay aktivasyonu</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Döllenme yokluğu ve azlığı ve globozoospermide yararı olabilir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mitokondri replasman tedavisi</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Araştırma protokolleri dışında kullanılmamalıdır</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVA</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Sınırlı etkinlik, yüksek maliyet ve güvenlik sorunları</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVM</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Uzun dönem riskleri, işlem güvenilirliği ve etkinliği belirsiz</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Sperm DNA hasarı test/tedavileri</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Sadece araştırma protokollerinde uygulanmalıdır</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Spermin yapay aktivasyonu</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Sadece sperm hücrelerinin tamamı hareketsiz ise yapılabilir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Sperm değerlendirme ve seçimi</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>

                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PICSI</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Standardizasyonu ve klinik yararı sınırlı</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">MACS</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Yeterli kanıt yok</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Microfluidics (mikroçip)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Daha fazla araştırma gerekli</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Büyüme faktörü destekli embriyo kültür ortamı</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Yeterli kanıt yok</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Assisted hatching (yuvalama)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Yararı yok, tek yumurta ikizi riskini arttırabilir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Genetik test/tedaviler</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PGT-A</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Belirli hasta gruplarında gebeliğe ulaşma süresini kısaltabilir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">niPGT</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Klinik uygulama için henüz uygun değil</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mitochondri DNA yükü ölçümü</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">niPGT ve mitokondrial DNA yükü ölçümü, araştırma aşamasındadır</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Time-lapse imaging (TLI)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Canlı doğum oranını arttırmamaktadır</div>
                                </div>
                            </div>
                        </div>

                        <h2>Klinik Yönetim</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">İŞLEM</div>
                                    <div class="divTableCell">ÖNERİ</div>
                                    <div class="divTableCell">AÇIKLAMA</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PRP (Platelet Rich Plasma)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Araştırma protokolleri dışında önerilmemektedir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Duostim</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Etkinlik ve güvenlik verisi yok. Acil üreme koruma durumunda olabilir, düşük yumurtalık rezervinde kullanımı için ileri araştırmalar gerekir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Yumurta geliştirme aşamasında ek tedaviler</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Metformin, büyüme hormonu, testosterone, DHEA, aspirin, indomethacin, sildenafil</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Vagina ve rahim içine kültür gereci</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Kanıt yoktur</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Kültür ortamına eklemeler (HA)</div>
                                    <div class="divTableCell">EVET?</div>
                                    <div class="divTableCell">Sadece tek embryo transfer politikası uygulanacaksa eklenmelidir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometrial scratching (rahim içini çizme işlemi)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Daha fazla çalışmaya ihtiyaç vardır</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Rahim içinin yıkanması (Hcg, G-CSF, emryo culture supernatant, seminal plasma)</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Daha fazla çalışmaya ihtiyaç vardır</div>

                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Kök hücre uygulamaları</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Gerekçesi belirsiz. Klinik uygulama öncesi çalışmalarla bu işlemin tüp bebek tedavileri ile ilgisi belirlenmelidir </div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Steroidler</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Mevcut verilere göre rutin uygulanmamalıdır</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Rutin dondurulmuş transfer</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Sadece klinik bir gerekçe varsa önerilmelidir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Rutin mikroenjeksiyon</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Sadece  belirgin sperm sorunu varsa tercih edilmelidir</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Erkekte veya kadında antioksidan tedavi</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Yeterince güvenilir ve iyi kalitede kanıt yok</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Tamamlayıcı ve alternatif tıp</div>
                                    <div class="divTableCell">HAYIR</div>
                                    <div class="divTableCell">Akupunktur verileri tartışmalı, diğerlerinde veri yok</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                else if (value === "ru") {
                    return <div>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">ПРОЦЕДУРА</div>
                                    <div class="divTableCell">РЕКОМЕНДАЦИЯ</div>
                                    <div class="divTableCell">ОПИСАНИЕ</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Диагностическая гистероскопия</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Может быть полезна при повторных неудачах ЭКО</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Тесты рецептивности эндометрия (ERA)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Нет доказанной пользы</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Иммунологические тесты и лечение в репродуктивной медицине</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Отсутствуют надежные референсные значения / неясные обоснование, побочные эффекты и клиническая польза</div>
                                </div>
                            </div>
                        </div>

                        <h2>Лабораторные тесты и вмешательства</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">ПРОЦЕДУРА</div>
                                    <div class="divTableCell">РЕКОМЕНДАЦИЯ</div>
                                    <div class="divTableCell">ОПИСАНИЕ</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Искусственная активация яйцеклетки</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Может быть полезна при отсутствии или низкой степени оплодотворения и при глободзооспермии</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Терапия замещения митохондрий</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Не должна использоваться вне исследовательских протоколов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVA</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Ограниченная эффективность, высокая стоимость и проблемы с безопасностью</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVM</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Неизвестные долгосрочные риски, надежность и эффективность процедуры</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Тест/лечение повреждения ДНК сперматозоидов</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Следует применять только в рамках исследовательских протоколов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Искусственная активация сперматозоидов</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Применяется только при полной неподвижности всех сперматозоидов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Оценка и отбор сперматозоидов</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PICSI</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Ограниченная стандартизация и клиническая польза</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">MACS</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Недостаточно доказательств</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Микрофлюидики (микрочип)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Необходимы дополнительные исследования</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Среда для культивирования эмбрионов с добавлением факторов роста</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Недостаточно доказательств</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Ассистированный хэтчинг</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Нет пользы, может увеличить риск однояйцевых близнецов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Генетические тесты/лечения</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PGT-A</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Может сократить время до наступления беременности в определенных группах пациентов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">niPGT</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Пока не пригоден для клинического применения</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Измерение уровня митохондриальной ДНК</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">niPGT и измерение митохондриальной ДНК находятся на стадии исследования</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Time-lapse визуализация (TLI)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Не увеличивает частоту живорождений</div>
                                </div>
                            </div>
                        </div>

                        <h2>Клиническое управление</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">ПРОЦЕДУРА</div>
                                    <div class="divTableCell">РЕКОМЕНДАЦИЯ</div>
                                    <div class="divTableCell">ОПИСАНИЕ</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PRP (богатая тромбоцитами плазма)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Не рекомендуется вне рамок исследовательских протоколов</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Duostim</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Нет данных об эффективности и безопасности. Может использоваться в экстренных случаях сохранения фертильности, необходимо больше исследований для применения при низком овариальном резерве</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Дополнительные методы лечения на стадии стимуляции яйцеклеток</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Метформин, гормон роста, тестостерон, DHEA, аспирин, индометацин, силденафил</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Материалы для посева во влагалище и матку</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Нет доказательств</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Добавки к среде культивирования (HA)</div>
                                    <div class="divTableCell">ДА?</div>
                                    <div class="divTableCell">Следует добавлять только при политике переноса одного эмбриона</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Скарификация эндометрия (царапание слизистой)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Необходимы дополнительные исследования</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Промывание полости матки (HCG, G-CSF, сверхнатант культуры эмбрионов, семенная плазма)</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Необходимы дополнительные исследования</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Применение стволовых клеток</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Неясное обоснование. Следует определить связь с ЭКО на основании исследований до клинического применения</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Стероиды</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Согласно имеющимся данным, не следует применять рутинно</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Рутинный перенос замороженных эмбрионов</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Рекомендуется только при наличии клинических показаний</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Рутинная микроинъекция</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Следует применять только при выраженной патологии спермы</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Антиоксидантная терапия у мужчин или женщин</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Недостаточно достоверных и качественных доказательств</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Дополнительная и альтернативная медицина</div>
                                    <div class="divTableCell">НЕТ</div>
                                    <div class="divTableCell">Данные по акупунктуре спорные, по остальным — отсутствуют</div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
                else if (value === "uz") {
                    return <div>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">USUL</div>
                                    <div class="divTableCell">TAVSIYA</div>
                                    <div class="divTableCell">TAVSIF</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Diagnostik gisteroskopiya</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Takroriy IVF muvaffaqiyatsizligida foydali bo‘lishi mumkin</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometriy reseptivlik testi (ERA)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Foydasi isbotlanmagan</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Immunologik testlar va davolash usullari</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Ishonchli referens qiymatlar mavjud emas / asoslanmagan, salbiy ta’sirlar va klinik foyda noaniq</div>
                                </div>
                            </div>
                        </div>

                        <h2>Laboratoriya tahlillari va aralashuvlar</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">USUL</div>
                                    <div class="divTableCell">TAVSIYA</div>
                                    <div class="divTableCell">TAVSIF</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Yumurtani sun’iy faollashtirish</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Urug‘lanish bo‘lmaganda yoki kam bo‘lsa, globozoospermiya holatida foydali bo‘lishi mumkin</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mitoxondrial terapiya</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Tadqiqotlardan tashqarida qo‘llanmasligi kerak</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVA</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Cheklangan foyda, yuqori xarajat va xavfsizlik muammolari</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVM</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Uzoq muddatli xavflari, ishonchliligi va samaradorligi noma’lum</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Sperm DNK shikastlanishini tekshirish/davolash</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Faqat tadqiqot protokollarida qo‘llanishi kerak</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Spermni sun’iy faollashtirish</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Faqat butunlay harakatsiz sperma holatlarida qo‘llanadi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Sperm tanlash va baholash</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PICSI</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Standartlashtirilmagan va klinik foydasi cheklangan</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">MACS</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Etarli dalillar yo‘q</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mikrochip (mikrofluidik)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Qo‘shimcha tadqiqotlar kerak</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">O‘sish omillari qo‘shilgan embrion madaniy muhit</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Etarli ilmiy asos yo‘q</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Yordamli hatch</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Foydasi yo‘q, bir tuxumli egizak xavfini oshiradi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>Genetik testlar / muolajalar</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PGT-A</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Ayrim bemorlarda homiladorlikka erishish vaqtini qisqartirishi mumkin</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">niPGT</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Klinik qo‘llanishga hali tayyor emas</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Mitoxondrial DNK darajasini o‘lchash</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">niPGT va bu testlar tadqiqot bosqichida</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Time-lapse tasvirlash (TLI)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Tirik tug‘ilish sonini oshirmaydi</div>
                                </div>
                            </div>
                        </div>

                        <h2>Klinik boshqaruv</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">USUL</div>
                                    <div class="divTableCell">TAVSIYA</div>
                                    <div class="divTableCell">TAVSIF</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PRP (trombositga boy plazma)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Faqat tadqiqot doirasida tavsiya etiladi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Duostim</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Samaradorligi va xavfsizligi haqida yetarli ma’lumot yo‘q. Faqat favqulodda holatlarda qo‘llanishi mumkin</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Oshqozonni rag‘batlantirish bosqichida qo‘llaniladigan davo usullari</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Metformin, o‘sish gormoni, testosteron, DHEA, aspirin, indometasin, sildenafil</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Vagina va bachadon uchun inokulyatsiya materiallari</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Foydasi isbotlanmagan</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Kultivatsiya muhitiga HA qo‘shilishi</div>
                                    <div class="divTableCell">HA?</div>
                                    <div class="divTableCell">Faqat bitta embrion transfer siyosati bo‘lsa qo‘shilishi mumkin</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Endometriy silliq qatlamini chizish (scratch)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Qo‘shimcha tadqiqotlar talab qilinadi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Bachadon yuvish (HCG, G-CSF, embrion suyuqligi, sperma plazmasi)</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Yana tadqiqot kerak</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Stam hujayralar bilan muomala</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Hali asoslanmagan. Klinik foydalanishdan oldin tadqiqot zarur</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Steroidlar</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Mavjud ma’lumotlarga ko‘ra odatdagi holatda tavsiya etilmaydi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Oddiy muzlatilgan embrion ko‘chirish</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Faqat klinik holatlarda tavsiya qilinadi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Oddiy mikroinjektsiya</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Faqat og‘ir sperma muammolarida qo‘llanadi</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Erkak yoki ayollarda antioksidant terapiya</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Etarlicha sifatli va ishonchli dalillar yo‘q</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">Qo‘shimcha va alternativ tibbiyot</div>
                                    <div class="divTableCell">YO‘Q</div>
                                    <div class="divTableCell">Akupunktura bo‘yicha qarama-qarshi ma’lumotlar mavjud, boshqalar uchun dalil yo‘q</div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
                else if (value === "ar") {
                    return <div>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">الإجراء</div>
                                    <div class="divTableCell">التوصية</div>
                                    <div class="divTableCell">الوصف</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">تنظير الرحم التشخيصي</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">قد يكون مفيدًا في حالات فشل أطفال الأنابيب المتكرر</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">اختبار تقبل بطانة الرحم (ERA)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لم تثبت فائدته بعد</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الاختبارات والعلاجات المناعية</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا توجد قيم مرجعية موثوقة / غير مثبتة، وقد تكون لها آثار سلبية وفائدة سريرية غير مؤكدة</div>
                                </div>
                            </div>
                        </div>

                        <h2>التحاليل المخبرية والتدخلات</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">الإجراء</div>
                                    <div class="divTableCell">التوصية</div>
                                    <div class="divTableCell">الوصف</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">تنشيط البويضة صناعيًا</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">قد يكون مفيدًا في حالات عدم أو ضعف الإخصاب مثل الغلوبوزوسبرميا</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">العلاج الميتوكوندري</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا ينبغي استخدامه خارج نطاق البحث العلمي</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVA</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">فائدة محدودة، تكلفة عالية ومخاوف تتعلق بالسلامة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">IVM</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">مخاطر طويلة الأمد وفعالية غير مؤكدة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">اختبار تلف الحمض النووي للحيوانات المنوية / علاجه</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">ينبغي استخدامه فقط ضمن بروتوكولات البحث</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">تنشيط الحيوانات المنوية صناعيًا</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يستخدم فقط في حالات انعدام الحركة الكاملة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>اختيار الحيوانات المنوية وتقييمها</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PICSI</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">غير موحد وفائدته السريرية محدودة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">MACS</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا توجد أدلة كافية</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الميكروشيب (الميكروفلويديك)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يتطلب المزيد من الأبحاث</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">بيئة حضانة الأجنة المعززة بعوامل النمو</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا توجد أدلة علمية كافية</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">المساعدة على الفقس (Assisted Hatching)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا فائدة مثبتة، وقد تزيد من خطر التوائم أحادية الزيجوت</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell"><b>الاختبارات / العلاجات الجينية</b></div>
                                    <div class="divTableCell"></div>
                                    <div class="divTableCell"></div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">PGT-A</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">قد يقلل من وقت الوصول للحمل في بعض الحالات</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">niPGT</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لم يثبت بعد لاستخدامه السريري</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">قياس مستوى الحمض النووي الميتوكوندري</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">niPGT وهذا التحليل ما زالا في طور البحث</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">التصوير الزمني (Time-Lapse Imaging)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا يزيد من معدلات الولادة الحية</div>
                                </div>
                            </div>
                        </div>

                        <h2>الإدارة السريرية</h2>

                        <div class="divTable">
                            <div class="divTableBody">
                                <div class="divTableRow">
                                    <div class="divTableCell">الإجراء</div>
                                    <div class="divTableCell">التوصية</div>
                                    <div class="divTableCell">الوصف</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">بلازما غنية بالصفائح (PRP)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يوصى بها فقط في إطار البحوث</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">تحفيز مزدوج (Duostim)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">معلومات غير كافية حول الفعالية والسلامة؛ قد يُستخدم في حالات استثنائية</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الأدوية المستخدمة في مرحلة التحفيز</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">ميتفورمين، هرمون النمو، التستوستيرون، DHEA، الأسبرين، الإندوميتاسين، السيلدينافيل</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">مواد التلقيح للمهبل والرحم</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لم تثبت فائدتها</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">إضافة حمض الهيالورونيك إلى الوسط</div>
                                    <div class="divTableCell">؟</div>
                                    <div class="divTableCell">يمكن استخدامها فقط في حالة نقل جنين واحد</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">كشط بطانة الرحم</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يتطلب المزيد من الدراسات</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">غسل الرحم (HCG، G-CSF، سائل الجنين، بلازما الحيوانات المنوية)</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يتطلب المزيد من الأبحاث</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">العلاج بالخلايا الجذعية</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">غير مثبت ويحتاج لمزيد من الدراسات قبل الاستخدام السريري</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الستيرويدات</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا يُوصى بها في الحالات العادية بناءً على الأدلة المتاحة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">نقل الأجنة المجمدة الروتيني</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يوصى بها فقط في حالات سريرية معينة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الحقن المجهري الروتيني</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">يُستخدم فقط في مشاكل الحيوانات المنوية الشديدة</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">العلاج بمضادات الأكسدة للرجال أو النساء</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">لا توجد أدلة كافية وموثوقة على الفعالية</div>
                                </div>
                                <div class="divTableRow">
                                    <div class="divTableCell">الطب التكميلي والبديل</div>
                                    <div class="divTableCell">لا</div>
                                    <div class="divTableCell">الأدلة حول الوخز بالإبر متضاربة، ولا توجد أدلة للباقي</div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
            }}
        </LocaleContext.Consumer>

    );
}
